import { ItemVariantOption } from "@pepdirect/shared/types";
import { ReactSelectDropdownOption } from "./types";

export function formatDropdownQty(quantity: number): ReactSelectDropdownOption {
  return { value: quantity.toString(), label: quantity.toString() };
}

export const getVariants = (
  itemVariantOptions: ItemVariantOption[]
): ReactSelectDropdownOption[] => {
  return itemVariantOptions
    .map((option) => ({
      isDisabled: option.isOutOfStock || option.inventoryQty === 0,
      label: getFirstViableVariant(option, "value").toString(),
      position: getFirstViableVariant(option, "position"),
      value: option._id,
    }))
    .sort((x, y) => Number(x.position) - Number(y.position))
    .map((variant) => ({
      isDisabled: variant.isDisabled,
      label: variant.label,
      value: variant.value,
    }));
};

export const getFirstViableVariant = (
  option: ItemVariantOption,
  key: "name" | "position" | "value"
): string | number => option.variantOption?.[key] || "";

export const getCurrentValue = (
  variants: ReactSelectDropdownOption[],
  currentId: string
): ReactSelectDropdownOption => {
  const formattedCurrentOption = variants.filter(
    ({ value }) => value === currentId
  );
  return {
    value: formattedCurrentOption.length
      ? formattedCurrentOption[0]?.value
      : "",
    label: formattedCurrentOption.length
      ? formattedCurrentOption[0]?.label.toString()
      : "",
  };
};
